module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABJCAMAAAD8DnOOAAAAPFBMVEX///9WmdQfd8U/a6/RM0vBOVeSvuP///9Gj88AZb0rWqXtKTnXL0aMuuFppNgddsQ6iMwKY7czWKDYL0V9j7xCAAAAB3RSTlPc8vr7/v7qRwR7rgAAAHBJREFUeAHt1oEGgDAQh/H/ESsRvf+TNppwkKjpSkbfxzCHH9g203lmvnyzSuqyIlkCuYWAgICAgICAgIBMF7N8RFKJIUNlvkO8fyNzZb7I68sDZNR7gYCANHriuYUbexn5rcQREBAQEBAQEBAQfYBsl7R+jUvz4nsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/fo.png
// module id = PSLx
// module chunks = 0